import _ from 'lodash'
import Backbone from 'backbone'
import Wizard from 'scoreboard/components/wizard'
import SpreadsheetChooser from 'scoreboard/imports/spreadsheet-chooser'
import ScorecardItemImportStep2 from './scorecard-item-import-step2'
import Import from 'scoreboard/imports/model/import'
import globals from 'scoreboard/components/globals'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'
import highlight from 'scoreboard/components/highlight'
import conductor from 'scoreboard/components/conductor'
import dateFormatMessage from 'scoreboard/imports/date-format-message'
import DataSourceTypeChooser from 'scoreboard/components/import-data-source/data-source-type-chooser'
import DbConnection from 'scoreboard/imports/db-connection'
import RestDataSelector from 'scoreboard/imports/rest/rest-data-selector'
import RestRequestForm from 'scoreboard/imports/rest/rest-request-form'

const spreadsheetViews = withCommonViews(SpreadsheetChooser)
const dbViews = withCommonViews(DbConnection)
const restViews = withCommonViews(RestRequestForm,RestDataSelector)

/**
 * Returns all the views in the wizard, given the views which vary in the
 * middle of the wizard
 */
function withCommonViews(...middleViews) {
	return [DataSourceTypeChooser]
		.concat(middleViews)
		.concat(ScorecardItemImportStep2)
}

var ScorecardItemImportWizard = Wizard.extend({

	/**
	 * A wizard for importing scorecard items
	 *
	 * @constructs
	 *
	 * @param {Object} [options]
	 *
	 * @param {Import} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
		let model = this.model = new Import({
			type: 'scorecard-item',
			dataSourceMetadata: {
				source: 'upload'
			}
		})
		let labels = {
			singular: 'scorecards.scorecardNode',
			plural: 'scorecards.scorecardNodes'
		}
		let initialViews = spreadsheetViews
		let opts = _.extend({
			model,
			views: initialViews,
			labels,
			example: true,
			downloadUrl: 'api/imports/scorecard_item_example.csv',
			instructions: this.buildInstructions(),
			doneKey: 'admin.import.run'
		}, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	next: function(options) {
		this._extendOptions(options)
		let views
		if (this.options.model.isSpreadsheet()) {
			views = spreadsheetViews
		} else if (this.options.model.isDatabase()) {
			views = dbViews
		} else {
			views = restViews
		}

		this.setViews(views)
		Wizard.prototype.next.apply(this, arguments)
	},

	/**
	 * Builds the instructions to display on Spreadsheet Chooser view
	 */
	buildInstructions: function () {
		// #50884 the first line of the instructions will be generated by spreadsheet-chooser.js
		// based on if a google or non-google spreadsheet source was selected
		// and these scorecard-item instructions will follow
		let instructions = '<p/>'
		instructions += '<ul>'
		instructions += `<li>${i18n.get('admin.import.scorecardItem.instructions.two')}</li>`
		instructions += `<li>${i18n.get('admin.import.scorecardItem.instructions.three')}</li>`
		instructions += `<li>${dateFormatMessage()}</li>`
		instructions += `<li>${i18n.get('admin.import.scorecardItem.instructions.five',
			highlight(i18n.get('admin.import.scorecardItem.instructions.five.example')))}</li>`
		if (config.tags) {
			let tags = config.tags.join(', ')
			instructions += `<li>${i18n.get('admin.import.scorecardItem.instructions.six',
				highlight(tags))}</li>`
		}
		if (config.units) {
			let units = config.units.join(', ')
			instructions += `<li>${i18n.get('admin.import.scorecardItem.instructions.seven',
				highlight(units))}</li>`
		}
		instructions += '</ul>'
		return instructions
	},

	cancel: function () {
		// delete uploaded file on cancel
		// checking if the model is new is not needed here, since
		// scorecard item imports are not saved to the db
		this.model.deleteFile()
	},

	finish: function () {
		this.trigger('done')

		if (conductor.section() === 'scorecards') {
			// force re-rendering of the screen even if the url is unchanged
			let url = `organizations/${globals.orgId}/scorecards`
			Backbone.history.loadUrl(url)

			let opts = {force: true}
			let id = _.get(appDisplay.navView().gardener.tree.get(), 'id')
			if (id) {
				opts.id = id
				// without this, there's an unnecessary request in the display
				// pane
				opts.autoSelectRoot = false
			} else {
				opts.orgId = globals.orgId
				opts.autoSelectRoot = true
			}
			// force the nav pane to display the tree
			appDisplay.navView().show(opts)
		} else {
			// #31681 when importing scorecard items from other sections
			// (such as a bookmarked scorecard item), just navigate to the
			// selected scorecard item
			let itemId = _.get(this.options, 'itemId')
			if (itemId) {
				let url = `scorecards/${itemId}`
				conductor.navigate(url, {trigger: true})
			}
		}
	}

})

export default ScorecardItemImportWizard

ScorecardItemImportWizard.__filename__ = 'scorecards/edit/import/scorecard-item-import-wizard.js'
